<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search_tips') || '库位编号/库位全称搜索......'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>

            <el-badge :value="checkedCount" class="ml-2">
              <b-button
                :disabled="checkedCount < 1"
                size="sm"
                variant="outline-success"
                @click="printTag"
                v-if="allow('P')"
              >
                <b-icon-plus></b-icon-plus>
                {{ $l('INDEX.btn_print_tag') || '标签打印' }}
              </b-button>
            </el-badge>

            <el-badge :value="checkedCount" class="ml-2">
              <b-button
                :disabled="checkedCount < 1"
                size="sm"
                class="ml-2"
                variant="outline-success"
                @click="batchRelocation"
                v-if="allow('R')"
              >
                {{ $l('btn_batch_relocation') || '批量移库' }}
              </b-button>
            </el-badge>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="120px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_locationStatus') || '状态'">
              <el-checkbox-group v-model="form.locationStatusList">
                <el-checkbox label="Y">
                  {{ $l('form_label_locationStatus_Y') || '有效' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('form_label_locationStatus_N') || '无效' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_locationNo') || '存放库位'">
              <el-input
                v-model.trim="form.locationNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_locType') || '库位类型'">
              <dict-select
                v-model="form.locTypeList"
                url="/sys/common/dict/system"
                :body="locTypeParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                multiple
                clearable
                size="small"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_locSellType') || '库位售卖类型'"
            >
              <dict-select
                v-model="form.locSellTypeList"
                url="/sys/common/dict/system"
                :body="locSellTypeParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                multiple
                clearable
                size="small"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_create_time') || '创建日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateBegin"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  locationStatusList: ['Y'],
}

export default {
  props: {
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      locTypeParams: { dictType: 'locType' },
      locSellTypeParams: { dictType: 'locSellType' },
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {
        keyword: '',
        sampleStyleNo: '',
        sampleBarcode: '',
        locationNo: '',
      }
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    printTag() {
      this.$emit('printTag')
    },
    batchRelocation() {
      this.$emit('batchRelocation')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
